import type { GameSlice } from '@/shared/lib/zustand-types';

export const HandoffStageKind = {
  Idle: 'idle',
  WordReveal: 'word-reveal',
  Vote: 'vote',
  ClochardGuess: 'mr-white-guess',
  RoundEnd: 'round-end',
} as const;
export type HandoffStageKind = (typeof HandoffStageKind)[keyof typeof HandoffStageKind];

export type HandoffStage =
  | { kind: typeof HandoffStageKind.Idle }
  | { kind: typeof HandoffStageKind.WordReveal; index: number }
  | { kind: typeof HandoffStageKind.Vote; index: number }
  | { kind: typeof HandoffStageKind.ClochardGuess }
  | { kind: typeof HandoffStageKind.RoundEnd };

export type StandaloneHandoffSlice = {
  handoff: HandoffStage;

  beginWordReveal: () => void;
  advanceWordReveal: () => void;
  beginVote: () => void;
  advanceVote: () => void;
  showClochardGuess: () => void;
  showRoundEnd: () => void;
  resetHandoff: () => void;
};

export const createStandaloneHandoffSlice: GameSlice<StandaloneHandoffSlice> = (set) => ({
  handoff: { kind: HandoffStageKind.Idle },

  beginWordReveal: () =>
    set((s) => {
      s.handoff = { kind: HandoffStageKind.WordReveal, index: 0 };
    }),

  advanceWordReveal: () =>
    set((s) => {
      if (s.handoff.kind !== HandoffStageKind.WordReveal) return;
      s.handoff.index += 1;
    }),

  beginVote: () =>
    set((s) => {
      s.handoff = { kind: HandoffStageKind.Vote, index: 0 };
    }),

  advanceVote: () =>
    set((s) => {
      if (s.handoff.kind !== HandoffStageKind.Vote) return;
      s.handoff.index += 1;
    }),

  showClochardGuess: () =>
    set((s) => {
      s.handoff = { kind: HandoffStageKind.ClochardGuess };
    }),

  showRoundEnd: () =>
    set((s) => {
      s.handoff = { kind: HandoffStageKind.RoundEnd };
    }),

  resetHandoff: () =>
    set((s) => {
      s.handoff = { kind: HandoffStageKind.Idle };
    }),
});
